import React from 'react';
import { Section } from './ui/Section';
import { Check, ArrowRight, Flame } from 'lucide-react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export default function IncludesSection() {
  const items = ['PDF principal — El Triángulo NOCHE explicado sin relleno', 'Plantilla: Descarga 6 minutos (lista y ejemplos)', 'Guión de Desenganche (frase exacta + qué hacer cuando vuelve)', 'Ritual mínimo (cómo elegir tus 3 señales sin complicarte)', 'Plan de 14 noches (qué hacer en cada fase)', 'Mini-protocolo para despertares de madrugada', 'Errores comunes que te sabotean'];
  const scrollToPricing = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <Section className="bg-brand-cream-dark" data-id="element-191">
      <div className="flex flex-col lg:grid lg:grid-cols-2 gap-12 items-center" data-id="element-192">
        <div data-id="element-193">
          <h2 className="font-heading text-4xl md:text-5xl text-white mb-8 uppercase tracking-wide" data-id="element-194">
            ¿Qué incluye <br data-id="element-195" />
            <span className="text-brand-indigo" data-id="element-196">APAGA LA MENTE</span>?
          </h2>

          <ul className="space-y-4 mb-10" data-id="element-197">
            {items.map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start" data-id="element-198">
                <motion.div initial={{
              scale: 0
            }} whileInView={{
              scale: 1
            }} transition={{
              delay: index * 0.1 + 0.2,
              type: 'spring'
            }} className="bg-brand-indigo/15 p-1 rounded-full mr-4 mt-1" data-id="element-199">
                  <Check className="text-brand-indigo" size={20} data-id="element-200" />
                </motion.div>
                <span className="text-xl text-slate-300" data-id="element-201">{item}</span>
              </motion.li>)}
          </ul>

          <p className="text-brand-amber italic text-xl mb-8 border-l-4 border-brand-amber pl-4" data-id="element-202">
            Todo diseñado para una cosa: que lo uses en la cama, no que «se vea
            lindo».
          </p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8
        }} className="relative flex justify-center mb-8 lg:hidden" data-id="element-203">
            <img src="https://cdn.magicpatterns.com/uploads/4vut6SFKDkiGXHBcSk84Zt/APAGA_LA_MENTE_COVER.png" alt="APAGA LA MENTE Bundle" className="relative w-full max-w-sm rounded-lg shadow-2xl animate-float" data-id="element-204" />
          </motion.div>

          <div className="flex flex-col items-start gap-3" data-id="element-205">
            <Button size="lg" pulse={true} className="w-full sm:w-auto" onClick={scrollToPricing} data-id="element-206">
              QUIERO MI SISTEMA AHORA <ArrowRight className="ml-2" size={20} data-id="element-207" />
            </Button>
            <div className="flex flex-col gap-1 ml-1" data-id="element-208">
              <div className="flex items-center gap-1 text-red-400 text-sm font-bold animate-pulse" data-id="element-209">
                <Flame size={14} data-id="element-210" />
                <span data-id="element-211">Últimas copias a este precio</span>
              </div>
              <span className="text-slate-500 text-xs" data-id="element-212">
                ✓ Garantía 7 días — 0 riesgo para ti
              </span>
            </div>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8
      }} className="relative hidden lg:flex justify-center" data-id="element-213">
          <img src="https://cdn.magicpatterns.com/uploads/4vut6SFKDkiGXHBcSk84Zt/APAGA_LA_MENTE_COVER.png" alt="APAGA LA MENTE Bundle" className="relative w-full max-w-md rounded-lg shadow-2xl transform hover:scale-105 transition-transform duration-500 animate-float" data-id="element-214" />
        </motion.div>
      </div>
    </Section>;
}